import { render } from "./Pagootromodal.vue?vue&type=template&id=390d9890&scoped=true"
import script from "./Pagootromodal.vue?vue&type=script&lang=js"
export * from "./Pagootromodal.vue?vue&type=script&lang=js"

import "./Pagootromodal.vue?vue&type=style&index=0&id=390d9890&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\frontend.avicola\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-390d9890"]])

export default __exports__